module.exports = __webpack_public_path__ + "img/tobala_1.bb67ea61.jpg";